<kiene-kiene-table [tableDescriptor]="historyTableDescriptor"> </kiene-kiene-table>
